import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { getDessert } from "../../data";

export default function Dessert() {
  let desserts = getDessert();

  return (
    <div>
      <h1 className="second_title mt-3">Dolci</h1>

      {desserts.map((recipe) => (
        <div key={recipe.id}>
          {" "}
          <img
            src={recipe.image.src}
            alt={recipe.image.alt}
            className="media_style"
          />
          <h4 className="focus_title">{recipe.name}</h4>
          <div
            className="col-12 content mt-3"
            dangerouslySetInnerHTML={{ __html: recipe.description }}
          />
          <div className="link_to_subpage">
            <NavLink
              className="col-12 link_to_subpage"
              to={`/Sanaalimentazioneesalute/Dolci/${recipe.id}`}
            >
              Continua a leggere...
            </NavLink>
          </div>
        </div>
      ))}

      <Outlet />
    </div>
  );
}
